import React from 'react';
import AiReportIcon from '@diligentcorp/atlas-react-icons/dist/esm/lens/AiReport.js';

const MONOCHROME_NAV_ICON_FILTER = 'brightness(0)';

/**
 * Local dev nav icon for Content authoring (document + chart + AI sparkle).
 * Deployed nav uses dil-ai-report-default-icon so the icon inherits white from the panel.
 */
export function ContentAuthoringNavIcon({ style }: { style?: React.CSSProperties }) {
  return (
    <AiReportIcon
      style={{
        ...style,
        filter: MONOCHROME_NAV_ICON_FILTER,
        color: 'currentColor',
      }}
    />
  );
}
